(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/receiver/receiver-details.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/receiver/receiver-details.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const isCorporateSite = svs.grassroots.shared.data.isCorporateSite;
const _svs$ui = svs.ui,
  Badge = _svs$ui.ReactBadge,
  ReactIcon = _svs$ui.ReactIcon,
  Button = _svs$ui.Button;
const Corporate = svs.grassroots.components.receiver.corporate;
const NonCorporate = svs.grassroots.components.receiver.non_corporate;
const ShareSocials = svs.grassroots.components.receiver.share_socials;
const ReceiverDetails = _ref => {
  let receiver = _ref.receiver;
  const id = receiver.id,
    longname = receiver.longname,
    shortname = receiver.shortname,
    subcategory = receiver.subcategory,
    supporters = receiver.supporters,
    points = receiver.points,
    location = receiver.location,
    homepage = receiver.homepage,
    yearlypayouts = receiver.yearlypayouts,
    latestperiodamount = receiver.latestperiodamount;
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    displayMorePayouts = _React$useState2[0],
    setDisplayMorePayouts = _React$useState2[1];
  const orderedYearlyPayoutYears = Object.keys(yearlypayouts !== null && yearlypayouts !== void 0 ? yearlypayouts : []).sort((a, b) => b - a);
  const toggleDisplayPayouts = () => {
    setDisplayMorePayouts(prev => !prev);
  };

  const displayToggleButton = () => {
    if (orderedYearlyPayoutYears.length > 2) {
      return React.createElement(Button, {
        branding: svs.grassroots.tenant,
        className: "right margin-bottom-1",
        onClick: toggleDisplayPayouts,
        size: 100,
        transparent: true
      }, !displayMorePayouts ? 'Visa fler' : 'Visa färre');
    }
  };

  const YearlyPayout = _ref2 => {
    var _yearlypayouts$year;
    let year = _ref2.year;
    return React.createElement("div", {
      className: "grid-row",
      key: year
    }, React.createElement("div", {
      className: "col-xs-6 align-left"
    }, React.createElement("p", null, year, ":")), React.createElement("div", {
      className: "col-xs-6 align-right"
    }, React.createElement("p", null, yearlypayouts === null || yearlypayouts === void 0 || (_yearlypayouts$year = yearlypayouts[year]) === null || _yearlypayouts$year === void 0 ? void 0 : _yearlypayouts$year.toLocaleString('sv-SE'), ' ', "kr")));
  };
  return React.createElement("div", {
    className: "padding-1 f-content grassroots-receiver-details-container"
  }, React.createElement("h1", {
    className: "grassroots-receiver-details-name h4"
  }, longname, ' ', subcategory ? React.createElement("p", {
    className: "inline-block f-normal"
  }, '- ', subcategory, ' ') : React.createElement(Badge, {
    className: "grassroots-badge"
  }, "Huvudf\xF6rening")), React.createElement("p", null, location === null || location === void 0 ? void 0 : location.city), React.createElement("p", null, React.createElement(ReactIcon, {
    className: "padding-right-1",
    icon: "players",
    size: "300"
  }), "".concat(supporters === null || supporters === void 0 ? void 0 : supporters.toLocaleString('sv-SE'), " st"), React.createElement(ReactIcon, {
    className: "padding-right-1 margin-left-1",
    icon: "points",
    size: "300"
  }), "".concat(points === null || points === void 0 ? void 0 : points.toLocaleString('sv-SE'), " p")), homepage && React.createElement("a", {
    className: "fc-navy",
    href: homepage,
    rel: "nofollow noopener noreferrer",
    target: "_blank"
  }, homepage, React.createElement(ReactIcon, {
    className: "u-text-decoration-none",
    icon: "link-external",
    size: 100
  })), React.createElement("div", {
    className: "margin-top-2 grid-row"
  }, React.createElement("div", {
    className: "col-xs-8 align-left"
  }, React.createElement("p", {
    className: "f-medium"
  }, "Sektionens senaste belopp:")), React.createElement("div", {
    className: "col-xs-4 align-right"
  }, React.createElement("p", null, latestperiodamount === null || latestperiodamount === void 0 ? void 0 : latestperiodamount.toLocaleString('sv-SE'), ' ', "kr"))), orderedYearlyPayoutYears.length > 0 && React.createElement("div", null, React.createElement("p", null, "F\xF6reningens \xE5rsbelopp:"), orderedYearlyPayoutYears.filter((_, index) => index < 2).map(year => React.createElement(YearlyPayout, {
    key: year,
    year: year
  })), displayMorePayouts && orderedYearlyPayoutYears.filter((_, index) => index > 1).map(year => React.createElement(YearlyPayout, {
    key: year,
    year: year
  })), displayToggleButton()), 
  id && (isCorporateSite ? React.createElement(Corporate, {
    id: id
  }) : React.createElement(NonCorporate, {
    receiver: receiver
  })), React.createElement(ShareSocials, {
    id: id,
    longname: longname,
    shortname: shortname
  }));
};
svs.grassroots.components.receiver.receiver_details = ReceiverDetails;

 })(window);